var React = require('react');

function InfoFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 16.316a1.053 1.053 0 01-1.053-1.053v-6.316a1.053 1.053 0 012.106 0v6.316c0 .582-.472 1.053-1.053 1.053zm0-10a1.053 1.053 0 110-2.105 1.053 1.053 0 010 2.105z","fill":"currentColor"}));
}

InfoFilled.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = InfoFilled;

InfoFilled.default = InfoFilled;
